import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { TranslocoModule } from "@ngneat/transloco";
import { FactoryResetConfirmComponent } from "./factory-reset-confirm.component";

@NgModule({
	imports: [CommonModule, IonicModule, TranslocoModule],
	declarations: [FactoryResetConfirmComponent],
	exports: [FactoryResetConfirmComponent],
})
export class FactoryResetConfirmModule {}
